import axios from "axios";
const FILE = axios.create({
  baseURL: process.env.VUE_APP_UPLOADER_URL,
});

FILE.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("wwp-token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "multipart/form-data";
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["Accept"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default FILE;
